import { styled, Link as MuiLink } from "@mui/material";
import { LinkProps } from "./Link.props";

export const Link = styled((props: LinkProps) => <MuiLink {...props} />, {
  shouldForwardProp: (prop) => prop !== "inheritFonts" && prop !== "inheritColor"
})(
  ({
    theme: {
      palette: { custom },
      typography: { body1 },
      breakpoints
    },
    type = "primary",
    inheritFonts = false,
    inheritColor = false
  }) => {
    let mainColor;
    let pressedColor;

    switch (type) {
      case "primary":
        mainColor = custom.turquoise.main;
        pressedColor = custom.turquoise.main;
        break;

      case "secondary":
        mainColor = custom.white.light;
        pressedColor = custom.turquoise.main;
        break;

      case "tertiary":
        mainColor = custom.white.main;
        pressedColor = custom.white.light;
        break;
    }

    return `
      color: ${inheritColor ? "inherit" : mainColor};
      text-decoration-color: ${inheritColor ? "inherit" : mainColor};
      font-size: ${inheritFonts ? "inherit" : body1.mobile.fontSize};
      line-height: ${inheritFonts ? "inherit" : body1.mobile.lineHeight};
      font-weight: ${inheritFonts ? "inherit" : body1.mobile.fontWeight};
      cursor: pointer;

      &:hover {
        color: ${pressedColor};
      }

      ${[breakpoints.up("md")]} {
        font-size: ${inheritFonts ? "inherit" : body1.tablet.fontSize};
        line-height: ${inheritFonts ? "inherit" : body1.tablet.lineHeight};
        font-weight: ${inheritFonts ? "inherit" : body1.tablet.fontWeight};
      }

      ${[breakpoints.up("lg")]} {
        font-size: ${inheritFonts ? "inherit" : body1.desktop.fontSize};
        line-height: ${inheritFonts ? "inherit" : body1.desktop.lineHeight};
        font-weight: ${inheritFonts ? "inherit" : body1.desktop.fontWeight};
      }
    `;
  }
);
